import serialize from "json-form-data";
import {addAuthKey} from '@/helpers/addAuthKeyToUrl';

const api_url = "/index.php";

export default {
    namespaced: true,

    actions: {
        async loadDocuments(ctx, params) {
            const token = ctx.rootState.authToken;
            return fetch(
                addAuthKey(`${api_url}/?r=api/type-documents/list&is_archive=${params.is_archive}`, token)
            )
                .then(res => res.json())
                .then(json => json.response);
        },

        async addDocumentType(ctx, params) {
            const token = ctx.rootState.authToken;
            const formData = serialize({ DocumentGroup: params.data });

            return fetch(
                addAuthKey(`${api_url}/?r=api/type-documents/create-doc-group`, token),
                {
                    method: "POST",
                    body: formData
                }
            );
        },

        async updateDocumentType(ctx, params) {
            const token = ctx.rootState.authToken;
            const formData = serialize({ DocumentGroup: params.data });

            return fetch(
                addAuthKey(`${api_url}/?r=api/type-documents/edit-doc-group&doc_group_id=${params.id}`, token),
                {
                    method: "POST",
                    body: formData
                }
            );
        },

        async removeDocumentType(ctx, params) {
            const token = ctx.rootState.authToken;
            return fetch(
                addAuthKey(`${api_url}/?r=api/type-documents/delete-doc-group&doc_group_id=${params.id}`, token)
            );
        },

        async removeDocument(ctx, params) {
            const token = ctx.rootState.authToken;
            return fetch(
                addAuthKey(`${api_url}/?r=api/type-documents/delete&type_doc_id=${params.id}`, token)
            );
        },

        async resort(ctx, params) {
            const token = ctx.rootState.authToken;
            const fd = new FormData();
            fd.append("list", JSON.stringify(params.list));
            return fetch(
                addAuthKey(`${api_url}/?r=api/type-documents/save-docs-sorts`, token),
                {
                    method: "POST",
                    body: fd
                }
            );
        },

        async moveDocument(ctx, params) {
            const token = ctx.rootState.authToken;

            return fetch(
                addAuthKey(`${api_url}/?r=api/type-documents/change-doc-parent&doc_group_id=${params.typeId}&type_doc_id=${params.id}`, token),
            );
        },

        async archiveDocument(ctx, params) {
            const token = ctx.rootState.authToken;

            const res = await fetch(
                addAuthKey(`${api_url}/?r=api/type-documents/archive-doc&id=${params.id}`, token),
            );

            const jsonData = await res.json();

            return jsonData;
        },

        async archiveGroup(ctx, params) {
            const token = ctx.rootState.authToken;

            const res = await fetch(
                addAuthKey(`${api_url}/?r=api/type-documents/archive-group&id=${params.id}`, token),
            );

            const jsonData = await res.json();

            return jsonData;
        }
    }
};
